var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.33333 0V7.33333H0V8.66667H7.33333V16H8.66667V8.66667H16V7.33333H8.66667V0H7.33333Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }